import { Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, useFormState } from 'react-final-form';
import QCXFinalAlternativeCurrencyField from '../final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXSelectMoedaAutocomplete from '../final-select-moeda-field/QCXSelectMoedaAutocomplete';

export default function QCXMoedaDespesaFormGroup({
  isConsult,
  handleValorNaMoedaOnBlur,
  valorValidators,
  intl,
}) {
  const { t } = useTranslation();

  const form = useForm();
  const { values } = useFormState();
  const tipo = values?.atributosAdicionais?.tipo;

  return (
    <>
      <Grid item xs={12} sm={12} md={4} lg={4}>
        {tipo !== 'DUE' && (
        <QCXSelectMoedaAutocomplete
          id="select-field-moeda-despesa"
          key="select-field-moeda-despesa"
          name="despesa.moeda.id"
          label={t('com.muralis.qcx.moeda.moedaDespesas')}
          disabled={isConsult}
          initialValues={values}
        />
        )}
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}>
        <QCXFinalAlternativeCurrencyField
          id="currency-valor-moeda-despesa-field"
          key="currency-valor-moeda-despesa-field"
          name="despesa.valorMoeda"
          label={t('com.muralis.qcx.moeda.moedaDespesasMoeda')}
          validate={valorValidators}
          onBlur={handleValorNaMoedaOnBlur(form, values, 'despesa.moeda', 'despesa.valorMoeda', 'despesa.valorReal')}
          disabled={isConsult || !values?.despesa?.moeda?.id}
          required={!!values?.despesa?.moeda?.id}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}>
        <QCXFinalAlternativeCurrencyField
          id="currency-valor-real-moeda-despesa-field"
          key="currency-valor-real-moeda-despesa-field"
          name="despesa.valorReal"
          label={t('com.muralis.qcx.moeda.moedaDespesasReais')}
          intl={intl}
          adorned
          disabled
          helperText={!(isConsult) && t('com.muralis.qcx.mensagem.arredondamentoValor')}
        />
      </Grid>
    </>
  );
}
